"use client";

import type { MultiSelectOption } from "./form-types";

import { CheckboxButton } from "@homeinstead/ui/components/Checkbox";
import Image from "next/image";

export interface MultiSelectCheckboxOptionProps {
  option: MultiSelectOption;
  checked: boolean;
  disabled: boolean;
  fieldName: string;
  onChange: (value: string, checked: boolean) => void;
}

export function MultiSelectCheckboxOption({
  option,
  checked,
  disabled,
  fieldName,
  onChange,
}: MultiSelectCheckboxOptionProps) {
  const optionValue = option.value ?? option.label ?? option._key;
  const inputName = `${fieldName}.${optionValue}`;
  const isDisabled = disabled && !checked;

  return (
    <CheckboxButton
      aria-label={option.label}
      buttonSize="short"
      checked={checked}
      containerClassName="md:w-full"
      disabled={isDisabled}
      id={inputName}
      name={inputName}
      onChange={(e) => onChange(optionValue, e.target.checked)}
    >
      <div className="flex items-center gap-3">
        {option.iconUrl && (
          <Image
            alt=""
            aria-hidden="true"
            className="size-5 shrink-0"
            height={20}
            src={option.iconUrl}
            width={20}
          />
        )}
        <span className="font-bold text-md">{option.label}</span>
      </div>
    </CheckboxButton>
  );
}
